import { render, staticRenderFns } from "./GestionCampus.vue?vue&type=template&id=daf74680"
import script from "./GestionCampus.vue?vue&type=script&lang=js"
export * from "./GestionCampus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports